import baseAPI from '@/http'

const router = 'api/pergunta/perguntamunicipio'

export const cityQuestionAPI = {
  getRespondidas: (id) => baseAPI.get(`${router}/get-perguntas-respondidas/${id}`),
  getEvidenciadas: (id) => baseAPI.get(`${router}/get-perguntas-municipios-evidenciadas/${id}`),
  getAprovadas: (id) => baseAPI.get(`${router}/get-perguntas-municipios-aprovadas/${id}`),
  getRejeitadas: (id) => baseAPI.get(`${router}/get-perguntas-municipios-rejeitadas/${id}`),
  getPergunta: (perguntaId) => baseAPI.get(`${router}/get-pergunta/${perguntaId}`),
  salvarEvidencias: (evidencia) => baseAPI.post(`${router}` + '/salvarevidencias', evidencia),
  getPerguntas: (municipioId) => baseAPI.get(`${router}/get-perguntas/${municipioId}`),
  getPDFPerguntas: (filtro) => baseAPI.post(`${router}/get-pdf-perguntas`, filtro, { responseType: 'blob' }),
  getPDFPerguntasTema: (temaId) => baseAPI.get(`${router}/get-pdf-perguntas-by-tema/${temaId}`, { responseType: 'blob' }),
  atualizarPergunta: (perguntaId) => baseAPI.put(`${router}` + '/atualizar-pergunta-municipio-evidencia/' +perguntaId)
}
